import { render, staticRenderFns } from "./GuestConversationModal.vue?vue&type=template&id=28e5c530&scoped=true"
import script from "./GuestConversationModal.vue?vue&type=script&lang=js"
export * from "./GuestConversationModal.vue?vue&type=script&lang=js"
import style0 from "./GuestConversationModal.vue?vue&type=style&index=0&id=28e5c530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e5c530",
  null
  
)

export default component.exports